import { t } from 'i18next'
import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  code: yup.string().min(6).max(6).required('Code is required'),
})

export const emailFormValidationSchema = yup.object().shape({
  email: yup
    .string()
    .email(
      () =>
        t('verificationPage.errorMessages.invalidEmail', {
          defaultValue: 'Invalid email address',
        }) || 'Please, enter a valid email'
    )
    .max(255)
    .required('Email is required'),
})
